export function init() {
	let form = document.querySelector('.js-newsletter');

	if (!form) {
		return;
	}

	let className = 'float-label';
	let fields = Array.from(form.querySelectorAll('.js-newsletter-field'));

	form.classList.add('is-enhanced');

	fields.forEach(field => {
		field.addEventListener('focus', () => field.classList.add(className), true);
		field.addEventListener('blur', e => field.classList.toggle(className, !!(e.target.value)), true);
	});
}
